export default function PageHero({
  eyebrow,
  title,
  lead,
  image,
  imageAlt = '',
  imagePosition = 'center center',
  className = '',
}) {
  const sectionClass = [
    'page-hero',
    image ? 'page-hero--image' : '',
    className,
  ].filter(Boolean).join(' ')

  return (
    <section className={sectionClass}>
      {image && (
        <div className="page-hero__media" aria-hidden={!imageAlt}>
          <img
            src={image}
            alt={imageAlt}
            className="page-hero__image"
            style={{ objectPosition: imagePosition }}
          />
        </div>
      )}
      <div className="mx-auto max-w-7xl page-hero__content">
        {eyebrow && <p className="page-hero__eyebrow">{eyebrow}</p>}
        <h1 className="page-hero__title">{title}</h1>
        {lead && <p className="page-hero__lead">{lead}</p>}
      </div>
    </section>
  )
}
